import request from '@/utils/request'

export default {
  /**
   * 根据商品ID列表/套餐ID列表获取该商家的所有酒水提成人列表
   * @returns {*}
   */
  listStaffWithByProductIds(data, params) {
    return request.post('/department-products/with-index/list-staff/by-product-ids', data, {
      params
    })
  }
}
